import type { TMake } from '@src-common/api/definitions/w4d-cars-types';

import { DEFAULT_MAX_AGE } from '../api/hardcoded-make-models';
import { IModelOptions } from '../model';

import { useModelConfig } from './useModelConfig';

const getYearsItems = (record: IModelOptions) => {
  const maxAge = record.maxAge ?? DEFAULT_MAX_AGE;
  const nowYear = new Date().getFullYear();
  const result = [];

  const minManufacturingYear = record.minManufacturingYear ?? nowYear - maxAge;

  for (let year = nowYear + 1; year >= minManufacturingYear; year--) {
    result.push({
      value: String(year),
      title: String(year),
    });
  }

  return result;
};

const useYears = (make?: TMake, model?: string) => {
  const modelConfig = useModelConfig(make, model);

  if (!modelConfig || !model) {
    return [];
  }

  return getYearsItems(modelConfig);
};

export { useYears };
